export default {
  INVESTOR_PROFILE_ON_CUSTOM_GOAL_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_CUSTOM_GOAL_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_CUSTOM_GOAL_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_CUSTOM_GOAL_COMMAND'),
};
